import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { dateFormat } from '../helper/StringUtils';

export const getIPFirewallData = (obj) => (dispatch) => {
  let query;
  if (!obj) {
    query = `${constants.API.IP_FIREWALL}`;
  } else {
    query = `${constants.API.IP_FIREWALL}?page=${obj.page}&size=${obj.size}`;
  }
  dispatch({
    payload: [],
    type: 'GET_IP_FIREWALL_DATA_REQUEST_INITIATED',
  });

  return httpservice()
    .get(query)
    .then((ipResponse) => {
      const rows = ipResponse.data.response.data.items;

      const count = ipResponse.data.response.data.totalItems;

      const mappedData = rows.map((data) => (
        {
          ...data,
          reason: data.reason ? data.reason : 'No Reason Provided',
          created_at: dateFormat(data.createdAt),
        }
      ));

      dispatch({
        payload: {
          data: mappedData,
          count,
        },
        type: 'GET_IP_FIREWALL_DATA_REQUEST_SUCCESS',
      });

      return mappedData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: 'GET_IP_FIREWALL_DATA_REQUEST_ERROR',
      });
    });
};

export const getIPFirewallDataById = (id) => (dispatch) => {
  const query = `${constants.API.IP_FIREWALL}/${id}`;
  dispatch({
    payload: [],
    type: 'GET_IP_FIREWALL_DATA_BY_ID_REQUEST_INITIATED',
  });

  return httpservice()
    .get(query)
    .then((ipFirewallData) => {
      dispatch({
        payload: { data: ipFirewallData.data },
        type: 'GET_IP_FIREWALL_DATA_BY_ID_REQUEST_SUCCESS',
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: 'GET_IP_FIREWALL_DATA_BY_ID_REQUEST_ERROR',
      });
    });
};

export const saveIPFirewallData = (saveData) => httpservice()
  .post(constants.API.IP_FIREWALL, saveData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const updateIPFirewallData = (id, modifiedData) => httpservice()
  .put(`${constants.API.IP_FIREWALL}/${id}`, modifiedData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const deleteIPFirewallData = (id) => httpservice()
  .delete(`${constants.API.IP_FIREWALL}/${id}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);
